module.exports = __webpack_public_path__ + "img/cms.6699fc8.svg";